import { Component, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: (err: Error, reset: () => void) => ReactNode;
}

interface State {
  err: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { err: null };

  static getDerivedStateFromError(err: Error): State {
    return { err };
  }

  componentDidCatch(err: Error, info: React.ErrorInfo): void {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', err, info);
  }

  reset = () => this.setState({ err: null });

  render(): ReactNode {
    const { err } = this.state;
    if (err) {
      if (this.props.fallback) return this.props.fallback(err, this.reset);
      return (
        <div className="min-h-[60vh] flex flex-col items-center justify-center gap-3 p-6 text-center">
          <div className="text-base font-semibold">页面出了点问题</div>
          <div className="max-w-md text-xs text-fg-muted">{err.message}</div>
          <div className="flex gap-2">
            <button
              onClick={this.reset}
              className="h-9 rounded-xl bg-accent text-accent-contrast px-4 text-sm"
            >
              重试
            </button>
            <button
              onClick={() => location.assign('/')}
              className="h-9 rounded-xl border border-border px-4 text-sm"
            >
              回首页
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
